<div class="inicio scroll-smooth">
    <section id="bannerSection">

        <!-- [imgBanner]="imgsHome?.banner" -->
        <app-homeone-banner [imgHeader]="imagesHome.header" [imgBanner]="imgsHome" [texts]="texts" (scrollToChat)="scrollToScheduleSection()"></app-homeone-banner>
    </section>

    <app-alert-temp-pass *ngIf="(isAuthenticated$ | async) && is_temp_password"></app-alert-temp-pass>

    <section id="featureSection">
        <!-- [imgFeatureH]="imgsHome?.feature_highlight" -->
        <app-feature-highlight *ngIf="dataLoaded" [imgFeatureH]="imagesHome.caracteristicasdestacadas" [texts]="texts"></app-feature-highlight>
    </section>

    <!-- <section id="chatSection" class="scroll-mt-32" #chatIaSection>
        <div>  class=" px-10 py-12 mx-16 my-24 bg-white rounded-lg shadow-lg shadow-verde1" 
            <app-image-content-card *ngIf="dataLoaded" [imgChatBot]="imagesHome.chatbot" [gifChatBot]="imgsHome?.gifChatBot"></app-image-content-card>
        </div>
    </section> -->

    <!-- <section id="videoSection">
        <app-video [imgVideo]="imagesHome.imagenvideo" [vidRuth]="imagesHome.video"></app-video>
    </section> -->

    <section id="cardsSection">
        <app-offer-card [imgMosaico]="imgsHome?.mosaico_cards" [texts]="texts"></app-offer-card>
    </section>

    <!-- <section id="pqrSection">
        <div class="bg-no-repeat bg-top bg-cover min-h-[600px] pb-[40px] mb-0 sm:mb-[100px] md:mb-[120px] lg:mb-[140px] xl:mb-[160px] 3xl:mb-[180px]" style="background-image: url('{{imgsHome?.map1}}');">
            <div class="container mx-auto px-[12px] 2xl:px-0 text-center mb-8 md:mb-10 lg:mb-12 xl:mb-14 pt-12">
                <h2 class="text-blanco font-bold font-serif text-[28px] md:text-[32px] lg:text-[38px] xl:text-[41px] 3xl:text-[57px] leading-[1.2] mb-[12px] lg:mb-[15px]" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
                    {{ texts?.cards_section?.title1 }}
                </h2>
                <p class="text-[16px] md:text-[20px] 3xl:text-[30px] text-blanco leading-[1.7] mb-[15px] xl:max-w-[700px] 3xl:max-w-[1200px] mx-auto" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">
                    {{ texts?.cards_section?.description }}
                </p>
            </div>

            <div class="flex flex-col items-center">
                <h2 class="text-blanco font-bold font-serif text-[28px] md:text-[32px] lg:text-[38px] xl:text-[41px] 3xl:text-[57px] leading-[1.2] text-center" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
                    {{ texts?.cards_section?.title2 }}
                </h2>
                <app-card-list *ngIf="dataLoaded" [icnsCards]="iconsHome" [texts]="texts"></app-card-list>
            </div>
        </div>
    </section> -->

    <!-- <section id="consultSection">
            <app-crm-pqrs [bgMapa2]="imgsHome?.map2" [imgConsult_pqr]="imagesHome.imagenpqrsf" [gifConsultPqrsf]="imgsHome?.gifConsultPqr" [texts]="texts"></app-crm-pqrs>
    </section> -->


    <section id="scheduleSection" #scheduleSection>
        <app-contact-options [imgAgenda]="imgsHome?.group_agenda" [texts]="texts"></app-contact-options>
    </section>

</div>

<!-- <a href="https://wa.me/573009137171?text=Hola%20Catia"
    id="whatsapp-link"
    class="whatsapp"
    target="_blank"
    data-aos="fade-up"
    data-aos-duration="400"
    data-aos-delay="0"
    (click)="handleWhatsappLinkClick($event)"
    >
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
        <path fill="currentColor" d="m7.254 18.494l.724.423A7.95 7.95 0 0 0 12.001 20a8 8 0 1 0-8-8a7.95 7.95 0 0 0 1.084 4.024l.422.724l-.653 2.401zM2.005 22l1.352-4.968A9.95 9.95 0 0 1 2.001 12c0-5.523 4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10a9.95 9.95 0 0 1-5.03-1.355zM8.392 7.308q.202-.014.403-.004q.081.006.162.016c.159.018.334.115.393.249q.447 1.015.868 2.04c.062.152.025.347-.093.537c-.06.097-.154.233-.263.372c-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268c.12.116.237.235.363.346c.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11q.093.039.191.066q.036.01.073.011a.35.35 0 0 0 .295-.142c.723-.876.79-.933.795-.933v.002a.48.48 0 0 1 .378-.127q.092.004.177.04c.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265c.004.067.01.175-.013.373c-.032.259-.11.57-.188.733a1.2 1.2 0 0 1-.21.302a2.4 2.4 0 0 1-.33.288q-.124.092-.125.09a5 5 0 0 1-.383.22a2 2 0 0 1-.833.23c-.185.01-.37.024-.556.014c-.008 0-.568-.087-.568-.087a9.45 9.45 0 0 1-3.84-2.046c-.226-.199-.436-.413-.65-.626c-.888-.885-1.561-1.84-1.97-2.742a3.5 3.5 0 0 1-.33-1.413a2.73 2.73 0 0 1 .565-1.68c.073-.094.142-.192.261-.305c.126-.12.207-.184.294-.228a1 1 0 0 1 .371-.1"/>
    </svg>
</a> -->
